import type { SVGProps } from 'react';
import * as React from 'react';

const SvgCopy12 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.5}
      d="M8.922 10.5H4.578c-.594 0-1.078-.558-1.078-1.244V4.244C3.5 3.558 3.984 3 4.578 3h4.344C9.516 3 10 3.558 10 4.244v5.012c0 .686-.484 1.244-1.078 1.244"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.5}
      d="M2.301 8.5A1.34 1.34 0 0 1 2 7.635V3.72C2 1.5 4.034 1.5 4.034 1.5h3.164c.322 0 .61.173.802.447"
    />
  </svg>
);
export default SvgCopy12;
